/** Default copy for quotation PDF when fields are left blank. */

export const DEFAULT_QUOTATION_INTRO =
  "Welcoming you to our family of satisfied customers we quote for packing and transportation of your Household / Office effects and/or Car.";

export const DEFAULT_PAYMENT_TERMS =
  "Payment terms as agreed. Advance and balance schedule to be confirmed at booking.";

export const DEFAULT_TERMS_AND_CONDITIONS = [
  "This quotation is valid for the period mentioned and is subject to survey of goods at origin unless waived.",
  "Final billing may vary based on actual volume, access, floor work, and services availed.",
  "Transit time is indicative and depends on route, weather, and regulatory halts.",
  "Insurance / carrier risk, if opted, will be as per policy terms and declared value.",
  "GST and statutory levies will be charged as applicable at the time of invoicing.",
  "Packing material quality and crew strength will match the agreed scope of work.",
  "Cancellation / postponement charges may apply as per company policy.",
  "Vehicle movement (if any) is subject to separate agreement and documentation.",
  "Storage, if required, will be charged additionally on actuals.",
  "Dispute resolution shall be subject to jurisdiction as per company terms of business.",
];
